import BroadcasterPageNavigationTracker from './navigation';


export const broadcasterPageNavigationTracker = new BroadcasterPageNavigationTracker();
